<script setup lang="ts">
definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/ai-funkce', de: '/ki-funktionen', pl: '/funkcje-ai' } })
</script>

<template>
  <MarketingFeaturePage seo-key="aiFeatures" path="/ai-features">
      <LazyHomepageAiFeaturesSection />
  </MarketingFeaturePage>
</template>
